/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nda_Status_Signed1Inputs */

const en_coinvestments_nda_status_signed1 = /** @type {(inputs: Coinvestments_Nda_Status_Signed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed`)
};

/**
* | output |
* | --- |
* | "Signed" |
*
* @param {Coinvestments_Nda_Status_Signed1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nda_status_signed1 = /** @type {((inputs?: Coinvestments_Nda_Status_Signed1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nda_Status_Signed1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nda_status_signed1(inputs)
});
export { coinvestments_nda_status_signed1 as "coInvestments_nda_status_signed" }